import { render, staticRenderFns } from "./BookingnoFlightDetails.vue?vue&type=template&id=181c6742&scoped=true"
import script from "./BookingnoFlightDetails.vue?vue&type=script&lang=js"
export * from "./BookingnoFlightDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingnoFlightDetails.vue?vue&type=style&index=0&id=181c6742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c6742",
  null
  
)

export default component.exports